import React from 'react'

const CustomSelect = ({
  value,
  name,
  options,
  handleChange,
  label,
  labelClassName,
  className,
  error,
  holder,
  ...props
}) => {

  const selectClassName = `
    h-12 w-full
    rounded-md
    px-4
    bg-cs-surface
    text-cs-dark
    border
    ${error ? 'border-cs-danger' : 'border-cs-border'}
    shadow-sm
    transition-all duration-200
    focus:outline-none
    focus:ring-2
    ${error ? 'focus:ring-cs-danger/30' : 'focus:ring-cs-primary/30'}
    appearance-none
    ${className}
  `

  const labelBaseClass = `
    text-sm
    font-medium
    text-cs-dark
    ${labelClassName}
  `

  const ErrorMensaje = () => {
    if (!error) return null

    return (
      <span className="mt-1 text-sm text-cs-danger">
        {error}
      </span>
    )
  }

  return (
    <div className="flex flex-col w-full py-2 gap-1">
      <label className={labelBaseClass}>{label}</label>

      <div className="relative">
        <select
          name={name}
          value={value}
          onChange={handleChange}
          className={selectClassName}
          {...props}
        >
          <option value="">{holder ?? 'Select'}</option>
          {options.map((item, index) => (
            <option value={item.id} key={index}>
              {item.name}
            </option>
          ))}
        </select>

        {/* Chevron */}
        <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-cs-muted">
          <svg
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </span>
      </div>

      <ErrorMensaje />
    </div>
  )
}

export default CustomSelect
